import { render } from "./App.vue?vue&type=template&id=c51954f6&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=c51954f6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jsrda\\OneDrive\\바탕 화면\\vue1\\colorpopgame\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c51954f6"]])

export default __exports__